import { Component, Input } from '@angular/core';

@Component({
  selector: 'zikatagov-checkbox',
  template: `
    <div class="form-check">
      <input
        type="checkbox"
        class="form-check-input"
        [id]="id"
        [disabled]="disabled"
      />
      <label class="form-check-label" [for]="id">
        <ng-content></ng-content>
      </label>
    </div>
  `,
  standalone: true
})
export class ZikataCheckboxComponent {
  @Input() id = '';
  @Input() disabled = false;
}
